var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSidebar)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block",attrs:{"href":"javascript:void(0)"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }